import { render } from "./ApiTokens.vue?vue&type=template&id=1d415e2e&ts=true"
import script from "./ApiTokens.vue?vue&type=script&lang=ts"
export * from "./ApiTokens.vue?vue&type=script&lang=ts"

import "./ApiTokens.vue?vue&type=style&index=0&id=1d415e2e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__